import {
  SearchField as SkapaSearchField,
  type SearchFieldProps as SkapaSearchFieldProps,
} from "@repo/skapa";
import { t } from "@repo/translation";

export type SearchFieldProps = SkapaSearchFieldProps;

export const SearchField = (props: SearchFieldProps) => {
  return (
    <SkapaSearchField
      clearBtnText={t("action.clear_search_field")}
      submitBtnText={t("action.submit_search")}
      {...props}
    />
  );
};
